import { useEffect } from 'react'
import { useSettingsStore } from '@/stores/settingsStore'

/**
 * Applies the theme preference to <html>. `system` attaches a live listener so
 * the app follows an OS theme switch without a reload.
 */
export function useThemeEffect(): void {
  const theme = useSettingsStore((state) => state.theme)

  useEffect(() => {
    const root = document.documentElement
    const media = window.matchMedia('(prefers-color-scheme: dark)')

    const apply = () => {
      const isDark = theme === 'dark' || (theme === 'system' && media.matches)
      root.classList.toggle('dark', isDark)
      root.dataset.theme = isDark ? 'dark' : 'light'
      root.style.colorScheme = isDark ? 'dark' : 'light'
    }

    apply()

    if (theme !== 'system') return
    media.addEventListener('change', apply)
    return () => media.removeEventListener('change', apply)
  }, [theme])
}
